const BulkReadingsTool = () => {
  return (
    <div>
      <h4 className='primary'>Bulk Readings Tool</h4>
    </div>
  );
};
export default BulkReadingsTool;
